/**
 * A formatter is something that takes some object and generally returns a string
 */

/**
 * Great for debugging objects. Used to pretty print objects
 */
export function stringify(object: Object, eol: string = '\n'): string {
    var cache = [];
    var value = JSON.stringify(object,
        // fixup circular reference
        function(key, value) {
            if (typeof value === 'object' && value !== null) {
                if (cache.indexOf(value) !== -1) {
                    // Circular reference found, discard key
                    return;
                }
                // Store value in our collection
                cache.push(value);
            }
            return value;
        },
        // indent 2 spaces
        2);
    value = value.split('\n').join(eol) + eol;
    cache = null;
    return value;
}

/** Allow any spaces and - */
export function removeSpacesAndHyphens(val: string): string {
  if (!val) return val;

  return val.replace(/\s*\-*/g, '');
}

export function cleanupPhoneNumbers(val: string): string {
  if (!val) return val;

  val = removeSpacesAndHyphens(val);

  /**
   * For country codes we need to remove trailing `0` if any
   * e.g. +610  => +61
   */
  const countryCodes = [
    '+61'
  ]
  const countryCodeMatch = countryCodes.find(c => val.startsWith(c + '0'));
  if (countryCodeMatch) {
    val = countryCodeMatch + val.substr(countryCodeMatch.length /** add 1 for 0 */ + 1);
  }

  return val;
}

import moment from 'moment';
export namespace Dates {
  /**
   * Returns 2011-03-12 12:00
   */
  export function longString(date: Date) {
    const formatted = date.toJSON().replace(/T/g, ' ').replace(/Z/, '');
    return formatted.substr(0, formatted.lastIndexOf(':'));
  }
  /**
   * Returns a date given a longString in UTC time
   */
  export function fromLongString(str: string): Date {
    const [date, time] = (str).split(' ');
    const [year, month, day] = date.split('-');
    const [hour, minutes] = time.split(':');
    const dateTime = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour),
      /** tell date time that it is utc */
      parseInt(minutes) - (new Date()).getTimezoneOffset());
    return dateTime;
  }
  export function longStringLocal(date: Date) {
    const d = new Date(date.getTime());
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return longString(d);
  }

  /**
   * Returns 2011-03-12
   */
  export function shortString(date: Date) {
    const formatted = date.toJSON().split(/T/g)[0];
    return formatted;
  }
  export function shortStringLocal(date: Date) {
    const d = new Date(date.getTime());
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return shortString(d);
  }

  /**
   * Return DD/MM/YYYY e.g. 21/06/2016
   */
  export function simpleDate(date: Date) {
    const day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
    const month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
    return `${day}/${month}/${date.getFullYear()}`;
  }

  /**
   * Return 1 Jul 2016
   * Cause it makes legal happy
   */
  export function happyDateLocal(date: Date) {
    return moment(date).format('D MMM YYYY');
  }
}
